import Immutable from 'seamless-immutable';
import * as SearchActions from '../actions/search.customer.actions';
export var INITIAL_STATE = Immutable({
  customerSearchModel: null
});
export default function SearchCustomersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case SearchActions.SET_CUSTOMER_SEARCH_MODEL:
      return state.set('customerSearchModel', payload);
    case SearchActions.RESET_SEARCH_CUSTOMER_MODEL_RECOVERABLE:
      return INITIAL_STATE;
    default:
      return state;
  }
}